import { InformationIcon } from "~/common/components";

interface DisabledReimbursementReportMessageProps {
  isGenerating?: boolean;
}

export const DisabledReimbursementReportMessage = ({
  isGenerating = false,
}: DisabledReimbursementReportMessageProps) => {
  return (
    <div className="flex gap-2 rounded-md bg-neutral-20 p-3 font-normal text-gray-35">
      <InformationIcon />
      {isGenerating ? (
        <p>
          The progress note is being prepared and will be available shortly.
          Please refresh the screen in a few minutes.
        </p>
      ) : (
        <p>
          The progress note will be available after the consultation is
          completed.
        </p>
      )}
    </div>
  );
};
